import { Link as RouterLink } from 'react-router-dom';
import Logout from '@mui/icons-material/Logout';
import { Avatar, Box, IconButton, Link, Stack, Typography } from '@mui/material';
import { alpha, styled } from '@mui/material/styles';
import moment from 'moment';
import { useStores } from 'src/models';

import { useAuthContext } from '../../../auth/useAuthContext';
import { CustomAvatar } from '../../../components/custom-avatar';
import { PATH_ROOT } from '../../../routes/paths';

// ----------------------------------------------------------------------

const StyledRoot = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: theme.spacing(2, 2.5),
  borderRadius: Number(theme.shape.borderRadius) * 1.5,
  backgroundColor: alpha(theme.palette.grey[500], 0.12),
}));

// ----------------------------------------------------------------------

export default function NavAccount() {
  const { user, logout } = useAuthContext();
  const rootStore = useStores();

  return (
    <Link component={RouterLink} to={PATH_ROOT.myInfo.root} underline="none" color="inherit">
      <StyledRoot>
        {/* <CustomAvatar src={user?.photoURL} alt={user?.displayName} name={user?.displayName} /> */}
        <Stack direction={'row'}>
          <Avatar />
          <Box sx={{ ml: 2, minWidth: 0 }}>
            <Typography variant="subtitle2" noWrap>
              {user?.userNm}
            </Typography>

            <Typography variant="body2" noWrap sx={{ color: 'text.secondary' }}>
              {moment(user?.lastLoginDt).format('YY/MM/DD HH:mm')}
            </Typography>
          </Box>
        </Stack>
        {/* <IconButton onClick={logout}>
        <Logout fontSize="small" />
      </IconButton> */}
      </StyledRoot>
    </Link>
  );
}
